import { Stack } from '@mui/material';
import { FormTextField } from '../../../design-system';
import { todayInSeoul, validDate, validDescriptor, validReason } from '../model/referenceData';
export type CommonCatalogDraft = {
  descriptor: string;
  effectiveDate: string;
  reason: string;
};
export function emptyCommonDraft(): CommonCatalogDraft {
  return {
    descriptor: '',
    effectiveDate: todayInSeoul(),
    reason: '',
  };
}
export function commonDraftValid(draft: CommonCatalogDraft, mode: 'create' | 'edit') {
  return (
    validDescriptor(draft.descriptor) &&
    validDate(draft.effectiveDate) &&
    (mode === 'create' || draft.effectiveDate <= todayInSeoul()) &&
    validReason(draft.reason)
  );
}
export function CommonCatalogFields({
  draft,
  mode,
  busy,
  descriptorHelper,
  onChange,
}: {
  draft: CommonCatalogDraft;
  mode: 'create' | 'edit';
  busy: boolean;
  descriptorHelper: string;
  onChange: <K extends keyof CommonCatalogDraft>(field: K, value: CommonCatalogDraft[K]) => void;
}) {
  return (
    <Stack spacing={2}>
      <FormTextField
        required
        label="이름"
        value={draft.descriptor}
        disabled={busy}
        error={draft.descriptor.length > 0 && !validDescriptor(draft.descriptor)}
        help={descriptorHelper}
        onChange={(event) => onChange('descriptor', event.target.value)}
        slotProps={{
          htmlInput: {
            maxLength: 120,
          },
        }}
      />
      <FormTextField
        required
        type="date"
        label="적용일"
        value={draft.effectiveDate}
        disabled={busy}
        error={!validDate(draft.effectiveDate) || (mode === 'edit' && draft.effectiveDate > todayInSeoul())}
        helperText={
          mode === 'edit'
            ? '속성 수정은 오늘 또는 이전 날짜에만 적용할 수 있습니다.'
            : '사용을 시작할 날짜입니다. 미래 시행도 예약할 수 있습니다.'
        }
        onChange={(event) => onChange('effectiveDate', event.target.value)}
        slotProps={{
          htmlInput:
            mode === 'edit'
              ? {
                  max: todayInSeoul(),
                }
              : undefined,
        }}
      />
      <FormTextField
        required
        multiline
        minRows={3}
        label="변경 사유"
        value={draft.reason}
        disabled={busy}
        error={draft.reason.length > 0 && !validReason(draft.reason)}
        helperText="감사 이력에 남길 사유를 500자 이하로 입력해 주세요."
        onChange={(event) => onChange('reason', event.target.value)}
        slotProps={{
          htmlInput: {
            maxLength: 500,
          },
        }}
      />
    </Stack>
  );
}
